export const getSelectedValueOrNull = (e: any): string | null => {
  const el = e.target as any
  const val = el.options[el.selectedIndex].value
  return val === 'null' ? null : val
}

export const getSelectedValue = (e: any): string => {
  const el = e.target as any
  return el.options[el.selectedIndex].value
}
